// Mirrors ovenmedia-middleware src/apps/apikey: a key carries the list of permissions it
// grants and only opens the routes declaring one of them.
export enum ApiKeyPermission {
  STATUS_READ = "status:read",
}

export const API_KEY_PERMISSION_DESCRIPTIONS: { [key in ApiKeyPermission]: string } = {
  [ApiKeyPermission.STATUS_READ]: "GET /status : streams, records, redirections, builds et uploads en cours",
};

/** Rate limit applied by the middleware to a key created without `rateLimitPerMinute`. */
export const API_KEY_DEFAULT_RATE_LIMIT_PER_MINUTE = 100;

export interface ApiKey {
  _id: string;
  _user: string;
  name: string;
  permissions: ApiKeyPermission[];
  filterIps?: string[];
  expiresAt?: string | null;
  lastUsedAt?: string;
  lastUsedIp?: string;
  revokedAt?: string;
  _revokedBy?: string;
  /** `null` → not limited. */
  rateLimitPerMinute?: number | null;
  createdAt: string;
  updatedAt: string;
}

/** Only returned by the creation: the plaintext secret, never retrievable afterwards. */
export interface CreatedApiKey extends ApiKey {
  secret: string;
}

export interface ApiKeyPayload {
  name: string;
  permissions: ApiKeyPermission[];
  filterIps: string[];
  expiresAt?: string | null;
  rateLimitPerMinute?: number | null;
}
